import { render, staticRenderFns } from "./ManagePromotion.vue?vue&type=template&id=30784972"
import script from "./ManagePromotion.vue?vue&type=script&lang=js"
export * from "./ManagePromotion.vue?vue&type=script&lang=js"
import style0 from "./ManagePromotion.vue?vue&type=style&index=0&id=30784972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports